import React from 'react';

const IndQualifiedPurchaser = ({ formData, handleChange, fieldErrors }) => {
    return (
        <fieldset className="form-field">
            <legend>
                The natural person described in Part I(a) above owns at least $5,000,000 of Investments as defined in Appendix A hereto.
            </legend>
            <label><input type="radio" name="qualifiedPurchaser.ownsFiveMil" value="true" checked={formData?.qualifiedPurchaser?.ownsFiveMil === 'true'} onChange={handleChange} required /> 
                True
            </label>
            <br/>
            <label><input type="radio" name="qualifiedPurchaser.ownsFiveMil" value="false" checked={formData?.qualifiedPurchaser?.ownsFiveMil === 'false'} onChange={handleChange} /> 
                False
            </label>

            {fieldErrors?.["qualifiedPurchaser.ownsFiveMil"] && (
            <div className="error-message" style={{ color: 'red', fontWeight: 'bold', marginTop: '0.5rem' }}>
                {fieldErrors["qualifiedPurchaser.ownsFiveMil"]}
            </div>
            )}

        </fieldset>
    );
};

export default IndQualifiedPurchaser;